import { render, staticRenderFns } from "./CodeList.vue?vue&type=template&id=4d823080&scoped=true"
import script from "./CodeList.vue?vue&type=script&lang=js"
export * from "./CodeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d823080",
  null
  
)

export default component.exports